import React, { Component } from "react";

class Header extends Component {
  state = { lookup: "" };
  constructor() {
    super();
    this.lookupRef = React.createRef();
  }
  onPresEnter = e => {
    if (e.key === "Enter") {
      this.props.enter();
    }
  };

  lookup = value => {
    var filteredQuery = 0;
    if (value.length > 9) {
      this.props.sendErrorMessage("Purchase Orders Must Be 1-9 Characters");
    }
    if (value.match(/[^\d.-]/g, "")) {
      this.props.sendErrorMessage("Purchase Orders Must Be Numeric");
    }
    filteredQuery = value.slice(0, 9).replace(/[^\d.-]/g, "");
    this.props.onChange(filteredQuery);
  };
  componentDidUpdate() {
    if (this.props.updatedSearchInput !== this.state.lookup) {
      this.setState({ lookup: this.props.updatedSearchInput });
    }
  }
  numberToZeroPadded = (num, z) => {
    var zeros = z - (num + "").length;
    for (let i = 0; i < zeros; i++) {
      num = "0" + num;
    }
    return num;
  };

  render() {
    return (
      <div className="grid-container">
        <div className="input-group element el1">
          <div className="input-group-prepend">
            <span className="input-group-text">PO Number</span>
          </div>
          <input
            autoFocus
            onChange={e => this.lookup(e.target.value)}
            type="text"
            min="0"
            value={this.state.lookup}
            className="form-control"
            onKeyPress={e => this.onPresEnter(e)}
          />
        </div>
        <div className={`input-group element el2`}>
          <div className="input-group-prepend">
            <span className="input-group-text">PM</span>
          </div>
          <input
            type="text"
            className={`form-control input2`}
            readOnly
            value={this.props.data ? this.props.data.pm : ""}
          />
        </div>
        <div className={`input-group element el3`}>
          <div className="input-group-prepend">
            <span className="input-group-text">vendor</span>
          </div>
          <input
            type="text"
            className={`form-control input3`}
            readOnly
            value={this.props.data ? this.props.data.originalVndr : ""}
          />
        </div>
        <div className={`input-group element el4`}>
          <div className="input-group-prepend">
            <span className="input-group-text">vendor name</span>
          </div>
          <input
            type="text"
            className={`form-control input4`}
            readOnly
            value={this.props.data ? this.props.data.vendorName : ""}
          />
        </div>
        <div className={`input-group element el5`}>
          <div className="input-group-prepend">
            <span className="input-group-text">store</span>
          </div>
          <input
            type="text"
            className={`form-control input5`}
            readOnly
            value={
              this.props.data
                ? this.numberToZeroPadded(this.props.data.store, 4)
                : ""
            }
          />
        </div>
        <div className={`input-group element el6`}>
          <div className="input-group-prepend">
            <span className="input-group-text">alt vendor</span>
          </div>
          <input
            type="text"
            className={`form-control input6`}
            readOnly
            value={
              this.props.data && this.props.data.alternateVndr !== null
                ? this.props.data.alternateVndr
                : ""
            }
          />
        </div>
        <div className={`input-group element el7`}>
          <div className="input-group-prepend">
            <span className="input-group-text">initial arrival date</span>
          </div>
          <input
            type="text"
            className={`form-control input7`}
            readOnly
            value={this.props.data ? this.props.data.initArrDate : ""}
          />
        </div>
        <div className={`input-group element el8`}>
          <div className="input-group-prepend">
            <span className="input-group-text">created</span>
          </div>
          <input
            type="text"
            className={`form-control input8`}
            readOnly
            value={this.props.data ? this.props.data.createDate : ""}
          />
        </div>
        <div className={`input-group element el9`}>
          <div className="input-group-prepend">
            <span className="input-group-text">modified</span>
          </div>
          <input
            type="text"
            className={`form-control input9`}
            readOnly
            value={this.props.data ? this.props.data.lastModified : ""}
          />
        </div>
        <div className={`input-group element el10`}>
          <div className="input-group-prepend">
            <span className="input-group-text">warehouse transfer</span>
          </div>
          <input
            type="text"
            className={`form-control input10`}
            readOnly
            value={this.props.data ? this.props.data.whseXferFlag : ""}
          />
        </div>
        <div className={`input-group element el11`}>
          <div className="input-group-prepend">
            <span className="input-group-text">printed</span>
          </div>
          <input
            type="text"
            className={`form-control input11`}
            readOnly
            value={this.props.data ? this.props.data.printDate : ""}
          />
        </div>
        <div className={`input-group element el12`}>
          <div className="input-group-prepend">
            <span className="input-group-text">PO note</span>
          </div>
          <input
            type="text"
            className={`form-control input12`}
            readOnly
            value={this.props.data ? this.props.data.poNote : ""}
          />
        </div>
      </div>
    );
  }
}

export default Header;
